import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import { 
  Paper, 
  Typography, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Divider,
  IconButton,
  Chip,
  Box
} from '@material-ui/core';
import { Visibility as VisibilityIcon, GetApp as DownloadIcon } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import HttpService from '../services/httpService';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  headerCell: {
    backgroundColor: '#1C375D',
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
    border: '1px solid #fff',
  },
  cityCell: {
    backgroundColor: '#1C375D',
    color: 'white',
    fontWeight: 'bold',
    cursor: 'pointer',
    border: '1px solid #fff',
  },
  totalCell: {
    fontWeight: 'bold',
    textAlign: 'center',
    border: '1px solid grey',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    }
  },
  grandTotalCell: {
    backgroundColor: '#1C375D',
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
    border: '1px solid grey',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.9,
    }
  },
  dataCell: {
    textAlign: 'center',
    cursor: 'pointer',
    border: '1px solid grey',
  },
  emptyCell: {
    textAlign: 'center',
    border: '1px solid #fff',
  },
  dialogContent: {
    minWidth: '500px',
    maxHeight: '400px',
  },
  snagItem: {
    border: '1px solid #e0e0e0',
    margin: '8px 0',
    borderRadius: '4px',
  },
  snagHeader: {
    backgroundColor: '#f5f5f5',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 16px',
  },
  eyeButton: {
    color: '#1C375D',
  },
  logsDialog: {
    minWidth: '600px',
  },
  logItem: {
    marginBottom: '16px',
  },
  logDate: {
    color: '#666',
    fontSize: '0.875rem',
  },
  logStatus: {
    marginBottom: '8px',
  },
  logHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '8px',
  },
  logContent: {
    paddingLeft: '8px',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    flexWrap: 'wrap',
  },
  downloadButton: {
    backgroundColor: '#1C375D',
    color: 'white',
    '&:hover': {
      backgroundColor: '#152642',
    },
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 24px',
  },
});

const ViewSnag = ({ setLoading, setSnackInfo }) => {
  const classes = useStyles();
  const [store, setStoreSnags] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedCitySnags, setSelectedCitySnags] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [logsDialogOpen, setLogsDialogOpen] = useState(false);
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedBucket, setSelectedBucket] = useState('');
  const [selectedProjectLogs, setSelectedProjectLogs] = useState([]);
  const [selectedProjectNo, setSelectedProjectNo] = useState('');

  // Download CSV function
  const downloadCSV = (data, filename) => {
    if (!data || data.length === 0) {
      setSnackInfo({ message: 'No data to download', severity: 'warning' });
      return;
    }

    try {
      // Define CSV headers based on your data structure
      const headers = [
        'Status',
        'Customer Name', 
        'Project No',
        'Aging In Days',
        'Created Date',
        'Last Log Date',
        'Location Name',
        'Location Code',
        'Material Status',
        'Snag Code'
      ];

      // Convert data to CSV format
      const csvContent = [
        headers.join(','), // Header row
        ...data.map(item => [
          `"${item.status || ''}"`,
          `"${item.customerName || ''}"`,
          `"${item.projectNo || ''}"`,
          item.agingInDays || '',
          `"${item.createdAt ? new Date(item.createdAt).toLocaleDateString() : ''}"`,
          `"${item.lastLogDate ? new Date(item.lastLogDate).toLocaleDateString() : ''}"`,
          `"${item.locationName || ''}"`,
          `"${item.locationCode || ''}"`,
          `"${item.materialStatus || ''}"`,
          `"${item.snagCode || ''}"`
        ].join(','))
      ].join('\n');

      // Create blob and download
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      console.log("url is",url)
      
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';


      console.log("calller is called")
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading CSV:', error);
      setSnackInfo({ message: 'Failed to download file', severity: 'error' });
    }
  };

  // Download current table data (summary)
  const handleDownloadSummary = () => {
    const summaryData = tableData.flatMap(city => 
      Object.entries(city.buckets || {}).map(([bucket, count]) => ({
        City: city.city,
        AgingBucket: bucket,
        Count: count,
        Total: city.total
      }))
    );
    
    downloadCSV(summaryData, `snag_summary_${new Date().toISOString().split('T')[0]}.csv`);
  };

  // Download detailed data from dialog
  const handleDownloadDetailed = () => {
    if (selectedCitySnags.length === 0) {
      setSnackInfo({ message: 'No data available to download', severity: 'warning' });
      return;
    }

    const filename = `snag_details_${selectedCity}_${selectedBucket}_${new Date().toISOString().split('T')[0]}.csv`;
    downloadCSV(selectedCitySnags, filename);
  };

  // Download project logs
  const handleDownloadLogs = () => {
    if (selectedProjectLogs.length === 0) {
      setSnackInfo({ message: 'No logs available to download', severity: 'warning' });
      return;
    }

    try {
      // Flatten the logs data for CSV
      const flattenedLogs = selectedProjectLogs.flatMap(document => 
        (document.materials || []).map(material => ({
          ProjectNo: selectedProjectNo,
          DocumentId: document.documentId || '',
          SnagCode: document.snagCode || '',
          DocumentStatus: document.status || '',
          DocumentCreated: document.createdAt ? new Date(document.createdAt).toLocaleDateString() : '',
          MaterialName: material.materialName || material.itemName || '',
          MaterialStatus: material.materialStatus || '',
          SpaceName: material.spaceName || '',
          ReasonForChange: material.reasonForChange || '',
          Remark: material.remark || '',
          AssignedTo: material.assignedToName || '',
          AssignedEmail: material.assignedUserEmail || '',
          AssignedDate: material.assignedDate ? new Date(material.assignedDate).toLocaleDateString() : '',
          AssignToDate: material.assignToDate ? new Date(material.assignToDate).toLocaleDateString() : '',
          TotalLogs: material.totalLogs || (material.logs ? material.logs.length : 0),
          Dimensions: `${material.length || ''}${material.breadth ? 'x' + material.breadth : ''}${material.thickness ? 'x' + material.thickness : ''}`
        }))
      );

      if (flattenedLogs.length === 0) {
        setSnackInfo({ message: 'No material data available to download', severity: 'warning' });
        return;
      }

      const headers = [
        'Project No',
        'Document ID',
        'Snag Code',
        'Document Status',
        'Document Created',
        'Material Name',
        'Material Status',
        'Space Name',
        'Reason For Change',
        'Remark',
        'Assigned To',
        'Assigned Email',
        'Assigned Date',
        'Assign To Date',
        'Total Logs',
        'Dimensions'
      ];

      const csvContent = [
        headers.join(','),
        ...flattenedLogs.map(item => [
          `"${item.ProjectNo}"`,
          `"${item.DocumentId}"`,
          `"${item.SnagCode}"`,
          `"${item.DocumentStatus}"`,
          `"${item.DocumentCreated}"`,
          `"${item.MaterialName}"`,
          `"${item.MaterialStatus}"`,
          `"${item.SpaceName}"`,
          `"${item.ReasonForChange}"`,
          `"${item.Remark}"`,
          `"${item.AssignedTo}"`,
          `"${item.AssignedEmail}"`,
          `"${item.AssignedDate}"`,
          `"${item.AssignToDate}"`,
          item.TotalLogs,
          `"${item.Dimensions}"`
        ].join(','))
      ].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      
      link.setAttribute('href', url);
      link.setAttribute('download', `project_logs_${selectedProjectNo}_${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      setSnackInfo({ message: 'Logs downloaded successfully', severity: 'success' });
    } catch (error) {
      console.error('Error downloading logs:', error);
      setSnackInfo({ message: 'Failed to download logs', severity: 'error' });
    }
  };

  const getSnags = async () => {
    try {
      setLoading(true);
      let res = await HttpService.getSnagReport();
      console.log(res.data.data,"this is data")
      
      const dataArray = Array.isArray(res.data.data) ? res.data.data : [];
      setStoreSnags(dataArray);
      
      const processedData = dataArray.map(location => ({
        city: location.locationName,
        buckets: location.agingBuckets || {},
        total: location.projectCount || 0,
        projects: location.projects || []
      }));
      
      setTableData(processedData);
    } catch (error) {
      console.log('Error fetching snag report:', error);
      setSnackInfo({ message: 'Failed to load snag report', severity: 'error' });
      setTableData([]);
    } finally {
      setLoading(false);
    }
  };

  // Function to get snags with multiple filters
  const getFilteredSnags = async (filters) => {
    try {
      setLoading(true);
      
      // Clean filters - remove undefined/null values
      const cleanFilters = {};
      if (filters.cityName !== undefined && filters.cityName !== null) {
        cleanFilters.cityName = filters.cityName;
      }
      if (filters.agingBucket !== undefined && filters.agingBucket !== null) {
        cleanFilters.agingBucket = filters.agingBucket;
      }
      
      console.log('Fetching snags with filters:', cleanFilters);
      
      // Call the API with filters (now using GET with query params)
      let response = await HttpService.findCityWiseSnag(cleanFilters);
      
      if (response && response.data && response.data.data) {
        const responseData = response.data.data;
        
        // Check if data is grouped (when cityName is undefined)
        if (responseData.isGrouped && responseData.groupedByCity) {
          // For grand total scenarios - flatten the grouped data
          const allProjects = [];
          responseData.groupedByCity.forEach(cityGroup => {
            if (cityGroup.projects && Array.isArray(cityGroup.projects)) {
              cityGroup.projects.forEach(project => {
                allProjects.push({
                  ...project,
                  locationName: cityGroup.locationName // Ensure location name is included
                });
              });
            }
          });
          setSelectedCitySnags(allProjects);
        } else if (responseData.projects) {
          // For specific city scenarios
          setSelectedCitySnags(responseData.projects);
        } else {
          setSelectedCitySnags([]);
        }
      } else {
        setSelectedCitySnags([]);
      }
      
    } catch (error) {
      console.log('Error fetching filtered snags:', error);
      setSnackInfo({ message: 'Failed to load snags', severity: 'error' });
      setSelectedCitySnags([]);
    } finally {
      setLoading(false);
    }
  };

  const getProjectLogs = async (projectNo) => {
    try {
      setLoading(true);
      let logsData = await HttpService.getProjectLogs({ projectNo });
      console.log(logsData?.data?.data?.projectDocuments,"this is the data iscalled")
      
      if (logsData && logsData?.data) {
        setSelectedProjectLogs(logsData?.data?.data?.projectDocuments || []);
        setSelectedProjectNo(projectNo);
        setLogsDialogOpen(true);
      } else {
        setSelectedProjectLogs([]);
        setSnackInfo({ message: 'No logs found for this project', severity: 'info' });
      }
    } catch (error) {
      console.log('Error fetching project logs:', error);
      setSnackInfo({ message: 'Failed to load project logs', severity: 'error' });
      setSelectedProjectLogs([]);
    } finally {
      setLoading(false);
    }
  };

  // Handle city name click - get all snags for that city
  const handleCityClick = async (cityName) => {
    const payload = { cityName };
    console.log('City clicked - Payload:', payload);
    
    setSelectedCity(cityName);
    setSelectedBucket('All Snags');
    await getFilteredSnags(payload);
    setDialogOpen(true);
  };

  // Handle aging bucket cell click - get snags for specific city and aging bucket
  const handleBucketClick = async (cityName, bucketName, bucketValue) => {
    if (bucketValue > 0) {
      const payload = {
        cityName,
        agingBucket: bucketName
      };
      console.log('Bucket clicked - Payload:', payload);
      
      setSelectedCity(cityName);
      setSelectedBucket(bucketName);
      await getFilteredSnags(payload);
      setDialogOpen(true);
    }
  };

  // Handle row total click - get all snags for that city
  const handleRowTotalClick = async (cityName, total) => {
    if (total > 0) {
      const payload = { cityName };
      console.log('Row Total clicked - Payload:', payload);
      
      setSelectedCity(cityName);
      setSelectedBucket('All Snags');
      await getFilteredSnags(payload);
      setDialogOpen(true);
    }
  };

  // Handle grand total bucket click - get all snags for specific aging bucket across all cities
  const handleGrandTotalBucketClick = async (bucketName, bucketValue) => {
    if (bucketValue > 0) {
      const payload = {
        agingBucket: bucketName
        // cityName is intentionally not included - will be sent as query param only if defined
      };
      console.log('Grand Total Bucket clicked - Payload:', payload);
      
      setSelectedCity('All Cities');
      setSelectedBucket(bucketName);
      await getFilteredSnags(payload);
      setDialogOpen(true);
    }
  };

  // Handle grand total click - get all snags across all cities
  const handleGrandTotalClick = async (total) => {
    if (total > 0) {
      const payload = {};
      console.log('Grand Total clicked - Payload:', payload);
      
      setSelectedCity('All Cities');
      setSelectedBucket('All Snags');
      await getFilteredSnags(payload);
      setDialogOpen(true);
    }
  };

  const handleViewLogs = (e, projectNo) => {
    e.stopPropagation();
    getProjectLogs(projectNo);
  };

  // Define the missing functions
  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedCitySnags([]);
    setSelectedCity('');
    setSelectedBucket('');
  };

  const handleCloseLogsDialog = () => {
    setLogsDialogOpen(false);
    setSelectedProjectLogs([]);
    setSelectedProjectNo('');
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString();
  };

  const formatDateTime = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  const calculateAge = (dateString) => {
    const now = new Date();
    const agingDate = new Date(dateString);
    const daysDiff = Math.floor((now - agingDate) / (1000 * 60 * 60 * 24));
    return `${daysDiff} days`;
  };

  useEffect(() => {
    getSnags();
  }, []);

  const grandTotals = tableData.reduce(
    (totals, row) => ({
      '0-5': totals['0-5'] + (row.buckets['0-5'] || 0),
      '5-10': totals['5-10'] + (row.buckets['5-10'] || 0),
      '10-15': totals['10-15'] + (row.buckets['10-15'] || 0),
      '15-20': totals['15-20'] + (row.buckets['15-20'] || 0),
      '20-25': totals['20-25'] + (row.buckets['20-25'] || 0),
      '25-30': totals['25-30'] + (row.buckets['25-30'] || 0),
      '30+': totals['30+'] + (row.buckets['30+'] || 0),
      total: totals.total + row.total
    }),
    { '0-5': 0, '5-10': 0, '10-15': 0, '15-20': 0, '20-25': 0, '25-30': 0, '30+': 0, total: 0 }
  );

  const renderCell = (value, isEmpty = false, cityName = '', bucketName = '') => (
    <TableCell 
      className={isEmpty ? classes.emptyCell : classes.dataCell}
      onClick={() => !isEmpty && value > 0 && handleBucketClick(cityName, bucketName, value)}
      style={{ cursor: value > 0 ? 'pointer' : 'default' }}
    >
      {value || 0}
    </TableCell>
  );

  return (
    <div style={{ margin: '50px auto', width: '90%', textAlign: 'center' }}>
       <div
        className={classes.headerContainer}
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="h4"
          gutterBottom
          style={{
            fontWeight: 'bold',
            color: '#1C375D',
            textAlign: 'center',
          }}
        >
          Snag Aging Bucket Report
        </Typography>
      </div>

            
      <Paper elevation={3}>
        <TableContainer className={classes.tableContainer}>
          <Table className={classes.table} aria-label="aging bucket table">
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell} rowSpan={2}>City</TableCell>
                <TableCell className={classes.headerCell} colSpan={7}>Ageing Bucket</TableCell>
                <TableCell className={classes.headerCell} rowSpan={2}>Total</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.headerCell}>0 - &lt;5 days</TableCell>
                <TableCell className={classes.headerCell}>&gt;5 - &lt;10</TableCell>
                <TableCell className={classes.headerCell}>&gt;10 - &lt;15</TableCell>
                <TableCell className={classes.headerCell}>&gt;15 - &lt;20</TableCell>
                <TableCell className={classes.headerCell}>&gt;20 - &lt;25</TableCell>
                <TableCell className={classes.headerCell}>&gt;25 - &lt;30</TableCell>
                <TableCell className={classes.headerCell}>&gt;30+</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.map((row) => (
                <TableRow key={row.city}>
                  <TableCell 
                    className={classes.cityCell}
                    onClick={() => handleCityClick(row.city)}
                  >
                    {row.city}
                  </TableCell>
                  {renderCell(row.buckets['0-5'], false, row.city, '0-5')}
                  {renderCell(row.buckets['5-10'], false, row.city, '5-10')}
                  {renderCell(row.buckets['10-15'], false, row.city, '10-15')}
                  {renderCell(row.buckets['15-20'], false, row.city, '15-20')}
                  {renderCell(row.buckets['20-25'], false, row.city, '20-25')}
                  {renderCell(row.buckets['25-30'], false, row.city, '25-30')}
                  {renderCell(row.buckets['30+'], false, row.city, '30+')}
                  <TableCell 
                    className={classes.totalCell}
                    onClick={() => handleRowTotalClick(row.city, row.total)}
                  >
                    {row.total || 0}
                  </TableCell>
                </TableRow>
              ))}
              {/* Grand Total Row */}
              <TableRow>
                <TableCell className={classes.grandTotalCell}>Grand Total</TableCell>
                <TableCell 
                  className={classes.grandTotalCell}
                  onClick={() => handleGrandTotalBucketClick('0-5', grandTotals['0-5'])}
                >
                  {grandTotals['0-5']}
                </TableCell>
                <TableCell 
                  className={classes.grandTotalCell}
                  onClick={() => handleGrandTotalBucketClick('5-10', grandTotals['5-10'])}
                >
                  {grandTotals['5-10']}
                </TableCell>
                <TableCell 
                  className={classes.grandTotalCell}
                  onClick={() => handleGrandTotalBucketClick('10-15', grandTotals['10-15'])}
                >
                  {grandTotals['10-15']}
                </TableCell>
                <TableCell 
                  className={classes.grandTotalCell}
                  onClick={() => handleGrandTotalBucketClick('15-20', grandTotals['15-20'])}
                >
                  {grandTotals['15-20']}
                </TableCell>
                <TableCell 
                  className={classes.grandTotalCell}
                  onClick={() => handleGrandTotalBucketClick('20-25', grandTotals['20-25'])}
                >
                  {grandTotals['20-25']}
                </TableCell>
                <TableCell 
                  className={classes.grandTotalCell}
                  onClick={() => handleGrandTotalBucketClick('25-30', grandTotals['25-30'])}
                >
                  {grandTotals['25-30']}
                </TableCell>
                <TableCell 
                  className={classes.grandTotalCell}
                  onClick={() => handleGrandTotalBucketClick('30+', grandTotals['30+'])}
                >
                  {grandTotals['30+']}
                </TableCell>
                <TableCell 
                  className={classes.grandTotalCell}
                  onClick={() => handleGrandTotalClick(grandTotals.total)}
                >
                  {grandTotals.total}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Dialog for showing city snags */}
      <Dialog 
        open={dialogOpen} 
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">
              {selectedCity} - {selectedBucket} ({selectedCitySnags.length} items)
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          {selectedCitySnags.length > 0 ? (
            <List>
              {selectedCitySnags.map((snag, index) => (
                <div key={index}>
                  <ListItem className={classes.snagItem}>
                    <ListItemText
                      primary={
                        <div className={classes.snagHeader}>
                          <Typography variant="h6">
                            {snag.projectNo} - {snag.customerName}
                          </Typography>
                          <IconButton
                            className={classes.eyeButton}
                            size="small"
                            onClick={(e) => handleViewLogs(e, snag.projectNo)}
                            title="View Logs"
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </div>
                      }
                      secondary={
                        <div>
                          <Typography variant="body2">
                            <strong>Status:</strong> {snag.status || snag.materialStatus}
                          </Typography>
                          <Typography variant="body2">
                            <strong>Created:</strong> {formatDate(snag.createdAt)}
                          </Typography>
                          {snag.lastLogDate && (
                            <Typography variant="body2">
                              <strong>Last Activity:</strong> {formatDate(snag.lastLogDate)} ({calculateAge(snag.lastLogDate)})
                            </Typography>
                          )}
                          <Typography variant="body2">
                            <strong>Location:</strong> {snag.locationName || snag.locationCode}
                          </Typography>
                        </div>
                      }
                    />
                  </ListItem>
                  {index < selectedCitySnags.length - 1 && <Divider />}
                </div>
              ))}
            </List>
          ) : (
            <Typography variant="body1" style={{ textAlign: 'center', margin: '20px' }}>
              No snags found for {selectedCity} in {selectedBucket}
            </Typography>
          )}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            variant="contained"
            className={classes.downloadButton}
            startIcon={<DownloadIcon />}
            onClick={handleDownloadDetailed}
            disabled={selectedCitySnags.length === 0}
          >
            Download CSV
          </Button>
          <Button onClick={handleCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog for showing project logs */}
      <Dialog 
        open={logsDialogOpen} 
        onClose={handleCloseLogsDialog}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="flex-start">
            <div>
              <Typography variant="h6">
                Project Details - {selectedProjectNo}
              </Typography>
              {selectedProjectLogs.length > 0 && (
                <Typography variant="subtitle2" color="textSecondary">
                  Total Materials: {selectedProjectLogs.reduce((total, doc) => total + (doc.materials?.length || 0), 0)}
                </Typography>
              )}
            </div>
          </Box>
        </DialogTitle>
        <DialogContent className={classes.logsDialog}>
          {selectedProjectLogs.length > 0 && Array.isArray(selectedProjectLogs) ? (
            <div>
              <Typography variant="h6" gutterBottom style={{ marginTop: '16px' }}>
                All Snags/Materials ({selectedProjectLogs.reduce((total, doc) => total + (doc.materials?.length || 0), 0)})
              </Typography>
              
              {selectedProjectLogs.map((document, docIndex) => (
                <div key={document.documentId || docIndex} style={{ marginBottom: '24px' }}>
                  <Typography variant="subtitle1" style={{ 
                    fontWeight: 'bold', 
                    marginBottom: '12px', 
                    color: '#1C375D',
                    backgroundColor: '#f5f5f5',
                    padding: '8px 12px',
                    borderRadius: '4px'
                  }}>
                    {document.snagCode} - {document.status}
                    <Typography variant="caption" style={{ marginLeft: '12px', color: '#666' }}>
                      Created: {formatDate(document.createdAt)}
                    </Typography>
                  </Typography>
                  
                  {document.materials && Array.isArray(document.materials) && document.materials.length > 0 ? (
                    document.materials.map((material, materialIndex) => (
                      <div key={material.materialId || materialIndex} className={classes.logItem} style={{
                        borderLeft: material.isAssignedToCurrentUser ? '4px solid #4CAF50' : '4px solid #FF9800',
                        marginLeft: '16px',
                        marginBottom: '12px'
                      }}>
                        <div className={classes.logHeader}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: "5px" }}>
                            <Chip 
                              label={material.materialStatus || 'No Status'} 
                              size="small" 
                              color={material.materialStatus === 'Completed' ? 'primary' : 'default'}
                            />
                          </div>
                        </div>
                        
                        <div className={classes.logContent}>
                          <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
                            {material.materialName || material.itemName || `Material #${materialIndex + 1}`}
                          </Typography>
                          
                          {material.snagCode && (
                            <Typography variant="body2" color="textSecondary">
                              <strong>Snag Code:</strong> {material.snagCode}
                            </Typography>
                          )}
                          
                          {material.spaceName && (
                            <Typography variant="body2" color="textSecondary">
                              <strong>Space:</strong> {material.spaceName}
                            </Typography>
                          )}
                          
                          {material.reasonForChange && (
                            <Typography variant="body2" color="textSecondary">
                              <strong>Reason:</strong> {material.reasonForChange}
                            </Typography>
                          )}
                          
                          {material.remark && (
                            <Typography variant="body2" color="textSecondary">
                              <strong>Remark:</strong> {material.remark}
                            </Typography>
                          )}
                          
                          <Typography variant="body2" color="textSecondary">
                            <strong>Assigned to:</strong> {material.assignedToName || 'Unknown User'}
                            {material.assignedUserEmail && ` (${material.assignedUserEmail})`}
                          </Typography>
                          
                          {material.assignedDate && (
                            <Typography variant="body2" color="textSecondary">
                              <strong>Assigned Date:</strong> {formatDate(material.assignedDate)}
                            </Typography>
                          )}
                          
                          {material.assignToDate && (
                            <Typography variant="body2" style={{ color: '#d32f2f', fontWeight: 'bold' }}>
                              <strong>Assigned Date:</strong> {formatDateTime(material.assignToDate)} ({calculateAge(material.assignToDate)})
                            </Typography>
                          )}
                          
                          <Typography variant="body2" color="textSecondary">
                            <strong>Total Logs:</strong> {material.totalLogs || (material.logs ? material.logs.length : 0)}
                          </Typography>
                          
                          {(material.length || material.breadth || material.thickness) && (
                            <Typography variant="body2" color="textSecondary">
                              <strong>Dimensions:</strong> {material.length ? `L: ${material.length}` : ''} 
                              {material.breadth ? ` × B: ${material.breadth}` : ''}
                              {material.thickness ? ` × T: ${material.thickness}` : ''}
                            </Typography>
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <Typography variant="body2" color="textSecondary" style={{ marginLeft: '16px' }}>
                      No materials found for this document.
                    </Typography>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <Typography variant="body1" style={{ textAlign: 'center', margin: '20px' }}>
              No project documents found for project {selectedProjectNo}
            </Typography>
          )}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
        
          <Button onClick={handleCloseLogsDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(ViewSnag);
